import { PropTypes } from "prop-types";

// Normalize any size prop (50, "50px", "75em") to a px value — callers mix
// units but all mean pixels.
const toCssSize = (value) => {
  if (value == null) return undefined;
  if (typeof value === "number") return `${value}px`;
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? undefined : `${parsed}px`;
};

export const Loading = ({
  height,
  width,
  loading_message: loadingMessage,
  children,
}) => {
  const cssHeight = toCssSize(height);
  const cssWidth = toCssSize(width);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <img
        src="/images/NuclearN1-B.gif"
        alt="Content Loading Spinner"
        // Inline style is required: Tailwind's preflight rule
        // `img, video { max-width: 100%; height: auto }` overrides width/height
        // attributes, rendering the gif at its natural 1080px size.
        style={{
          height: cssHeight ?? (cssWidth ? undefined : "50px"),
          width: cssWidth,
        }}
      />
      <div>{loadingMessage}</div>
      <div>{children}</div>
    </div>
  );
};

Loading.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loading_message: PropTypes.string,
  children: PropTypes.node,
};
